import { useEffect, useState } from "react";
import { useLoginContext } from "../../../App";
import { fetchProductsData } from "../../../services/b2b-users-apiService";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const useGetProducts = () => {
    const { loginData } = useLoginContext();
    const [fetchingProductsData, setFetchingProductsData] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const queryClient = useQueryClient();
    
    const sortProducts = (products) => {
        return products.sort((a, b) => {
            if (a.childProducts.length > 0 && b.childProducts.length === 0) {
                return 1;
            }
            if (a.childProducts.length === 0 && b.childProducts.length > 0) {
                return -1;
            }
            return a.productName.localeCompare(b.productName);
        }).map(product => ({
            ...product,
            childProducts: sortProducts(product.childProducts)
        }));
    };

    const fetchProducts = async () => {
        try {
            if ((loginData) && (!fetchingProductsData)) {
                const { accessToken } = loginData;
                setFetchingProductsData(true);
                let data = await fetchProductsData(accessToken);
                data = sortProducts(data);
                return data;
            }
        } catch (error) {
            console.error('Failed to fetch products data:', error.message);
        } finally {
            setFetchingProductsData(false);
        }
    };

    const { data: productsData } = useQuery({
        queryKey: ['productsData', loginData.loggedOrganizationUuid],
        queryFn: fetchProducts,
        enabled: !!loginData?.loggedOrganizationUuid,
    });

    useEffect(() => {
        if (refresh) {
            queryClient.invalidateQueries(['productsData', loginData.loggedOrganizationUuid]);
            setFetchingProductsData(true);
            setRefresh(false); 
        }
    }, [refresh, queryClient, loginData.loggedOrganizationUuid]);

    const triggerRefresh = () => {
        setRefresh(true);
    };

    return { productsData, fetchingProductsData, triggerRefresh };
}

export default useGetProducts;